module.exports = __webpack_public_path__ + "cc9863790b3d2325309f8820a8afd026.svg";